import type { JSX, ReactNode } from 'react';
import { useEffect } from 'react';

import styled from 'styled-components';

/* ----------------------------------
   Styled components
---------------------------------- */

export const ErrorValidation = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  margin: 4px 0;

  p {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: var(--neutral-1000, #101c16);
    margin-left: var(--spacing-base, 8px);
  }
`;

export const ErrorIcon = styled.div`
  width: 15px;
  height: 15px;
  background-image: url('/food/onboarding/assets/Alert.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

/* ----------------------------------
   Types
---------------------------------- */

interface ErrorFieldCheckProps {
  hasError?: boolean;
  isTouch?: boolean;
  errorMessage?: string | ReactNode;
  setIsTouch: (value: boolean) => void;
}

/* ----------------------------------
   Component
---------------------------------- */

export function ErrorFieldCheck({
  hasError,
  isTouch,
  errorMessage,
  setIsTouch
}: ErrorFieldCheckProps): JSX.Element {
  useEffect(() => {
    if (window.location.href.includes('review')) {
      setIsTouch(true);
    }
  }, [setIsTouch]);

  return (
    <>
      {hasError && isTouch ? (
        <ErrorValidation>
          <ErrorIcon />
          <p>{errorMessage}</p>
        </ErrorValidation>
      ) : (
        hasError &&
        window.location.href.includes('review') && (
          <ErrorValidation>
            <ErrorIcon />
            <p>{errorMessage}</p>
          </ErrorValidation>
        )
      )}
    </>
  );
}